<template>
    <div class="modelList_box">
        <div class="app_container">
            <div class="modelList_header">
                <ul class="modelList_items">
                    <li class="modelList_item" id='projectList_item' v-for="(model,index) in showList" v-bind:key="model.id">
                        <div class="modelList_thumbnails project_img_box" v-if="!model.off_thumb&&model.type=='1'" v-bind:style="{'background-image':'url(\'' + disposeBackguroudPath(model,model.projectThumbnail) +'\'),url(../../static/img/scene-default.png)'}" v-on:click="viewScene(model,true)" title="预览项目">
                            <div class="bottom_left tooltip-box top" data-content="预览项目" v-on:mouseenter="showTooltip" v-on:mouseleave="cancelTooltip" @click.stop="viewScene(model,true)" title="">
                                <i class="fa fa-search tooltip-box top" data-content="预览项目" style="font-size:1.2em;"></i>
                            </div>
                            <span class="indexAPP" @click.stop="viewScene"><i>{{index+1}}</i></span>
                            <div id="model_keyword">
                                <ul>
                                    <li v-html="$options.filters.highLightkeyWord(keyword)" v-if="$options.filters.highLightkeyWord(keyword)" v-for="(keyword) in model.keyWordArr" v-bind:key="keyword">{{keyword}}</li>
                                </ul>
                            </div>
                            <div class="isPay" v-if="model.isShopping==1
                                                || (model.isTemplate == 1 && model.terff != 0 && model.torder)"
                                                @click.stop="saleProject(model)">
                                购买
                            </div>
                        </div>
                        <div class="modelList_thumbnails project_img_box" v-if="model.off_thumb&&model.type=='1'" v-bind:style="{'background-image':'url(\''+ disposeBackguroudPath(model,model.off_thumb) +'\'),url(../../static/img/scene-default.png)'}" v-on:click="viewScene(model,true)" title="预览项目">
                            <div class="bottom_left tooltip-box top" data-content="预览项目" v-on:mouseenter="showTooltip" v-on:mouseleave="cancelTooltip" @click.stop="viewScene(model,true)" title="">
                                <i class="fa fa-search tooltip-box top" data-content="预览项目" style="font-size:1.2em;"></i>
                            </div>
                            <span class="indexAPP" @click.stop="viewScene"><i>{{index+1}}</i></span>
                            <div id="model_keyword">
                                <ul>
                                    <li v-html="$options.filters.highLightkeyWord(keyword)" v-if="$options.filters.highLightkeyWord(keyword)" v-for="(keyword) in model.keyWordArr" v-bind:key="keyword">{{keyword}}</li>
                                </ul>
                            </div>
                            <div class="isPay" v-if="model.isShopping==1
                                                || (model.isTemplate == 1 && model.terff != 0 && model.torder)"
                                                @click.stop="saleProject(model)">
                                购买
                            </div>
                        </div>
                        <div class="modelList_thumbnails project_img_box" v-if="!model.off_thumb&&model.type=='2'" v-bind:style="{backgroundImage:'url(\''+ processingUrl(model.picPath) +'\'),url(../../static/img/scene-default1.png)'}" v-on:click="viewCity(model,index,true)" title="预览地图">
                            <div class="bottom_left tooltip-box top" data-content="预览地图" v-on:mouseenter="showTooltip" v-on:mouseleave="cancelTooltip" @click.stop="viewCity(model,index,true)" title="">
                                <i class="fa fa-search tooltip-box top" data-content="预览地图" style="font-size:1.2em;"></i>
                            </div>
                            <span class="indexAPP" @click.stop="viewScene"><i>{{index+1}}</i></span>
                            <div id="model_keyword">
                                <ul>
                                    <li v-html="$options.filters.highLightkeyWord(keyword)" v-if="$options.filters.highLightkeyWord(keyword)"v-for="(keyword) in model.keyWordArr" v-bind:key="keyword">{{keyword}}</li>
                                </ul>
                            </div>
                            <div class="isPay" v-if="model.isShopping==1" @click.stop="saleCity(model)">购买</div>
                        </div>
                        <div class="modelList_thumbnails project_img_box" v-if="model.off_thumb&&model.type=='2'" v-bind:style="{backgroundImage:'url(\''+ model.off_thumb +'\'),url(../../static/img/scene-default1.png)'}" v-on:click="viewCity(model,index,true)" title="预览地图">
                            <div class="bottom_left tooltip-box top" data-content="预览地图" v-on:mouseenter="showTooltip" v-on:mouseleave="cancelTooltip" @click.stop="viewCity(model,index,true)" title="">
                                <i class="fa fa-search tooltip-box top" data-content="预览地图" style="font-size:1.2em;"></i>
                            </div>
                            <span class="indexAPP" @click.stop="viewScene"><i>{{index+1}}</i></span>
                            <div id="model_keyword">
                                <ul>
                                    <li v-html="$options.filters.highLightkeyWord(keyword)" v-if="$options.filters.highLightkeyWord(keyword)" v-for="(keyword) in model.keyWordArr" v-bind:key="keyword">{{keyword}}</li>
                                </ul>
                            </div>
                            <div class="isPay" v-if="model.isShopping==1" @click.stop="saleCity(model)">购买</div>
                        </div>
                        <div class="modelList_thumbnails project_img_box" v-if="!model.off_thumb&&(model.type=='3'||model.type=='4'||model.type=='5')" v-bind:style="{'background-image' : 'url(\'' + ((model.thumb&&model.thumb.indexOf('http')!=-1)?model.thumb:($global.MMD_URL+model.thumb)) + '\'),url(../../static/img/scene-default.png)' }"  @click.stop="noPlugInPreviewScene(model,true)" title="预览场景" >
                            <div class="bottom_left tooltip-box top" data-content="预览场景" v-on:mouseenter="showTooltip" v-on:mouseleave="cancelTooltip" @click.stop="noPlugInPreviewScene(model,true)" title="">
                                <i class="fa fa-search tooltip-box top" data-content="预览场景" style="font-size:1.2em;"></i>
                            </div>
                            <span class="indexAPP" @click.stop="viewScene"><i>{{index+1}}</i></span>
                            <div id="model_keyword">
                                <ul>
                                    <li v-html="$options.filters.highLightkeyWord(keyword)" v-if="$options.filters.highLightkeyWord(keyword)" v-for="(keyword) in model.keyWordArr" v-bind:key="keyword">{{keyword}}</li>
                                </ul>
                            </div>
                            <div class="isPay" v-if="model.isShopping==1" @click.stop="saleScenes(model)">购买</div>
                        </div>
                        <div class="modelList_thumbnails project_img_box" v-if="model.off_thumb&&(model.type=='3'||model.type=='4'||model.type=='5')" v-bind:style="{'background-image' : 'url(\'' + model.off_thumb + '\'),url(../../static/img/scene-default.png)'}"  @click.stop="noPlugInPreviewScene(model,true)" title="预览场景" >
                            <div class="bottom_left tooltip-box top" data-content="预览场景" v-on:mouseenter="showTooltip" v-on:mouseleave="cancelTooltip" @click.stop="noPlugInPreviewScene(model,true)" title="">
                                <i class="fa fa-search tooltip-box top" data-content="预览场景" style="font-size:1.2em;"></i>
                            </div>
                            <span class="indexAPP" @click.stop="viewScene"><i>{{index+1}}</i></span>
                            <div id="model_keyword">
                                <ul>
                                    <li v-html="$options.filters.highLightkeyWord(keyword)" v-if="$options.filters.highLightkeyWord(keyword)" v-for="(keyword) in model.keyWordArr" v-bind:key="keyword">{{keyword}}</li>
                                </ul>
                            </div>
                            <div class="isPay" v-if="model.isShopping==1" @click.stop="saleScenes(model)">购买</div>
                        </div>
                        <hr/>
                        <div class="modelList_info projectList_info" v-if="!((!model.off_thumb) && (!model.thumb) && (!model.username) && (!model.p_id))">
                            <div class="author_info project_author_info" v-if="model.type=='1'">
                                <a class="tooltip-box top" style = "cursor:auto">
                                    <img class="author_headImg" v-bind:src="disposeUrl(model.userNick,model.imgurl)?disposeUrl(model.userNick,model.imgurl):'../../static/img/thingjslogo.png'" onerror="src='../../static/img/thingjslogo.png'"/>
                                </a>
                                <span class="author_name" v-html="$options.filters.highLightMsg(model.projectName)" v-bind:title="model.projectName" @dblclick="selectText($event)">{{model.projectName}}</span>
                            </div>
                            <div class="author_info city_author_info" v-if="model.type=='2'||model.type=='4'||model.type=='5'">
                                <a class="tooltip-box top" style = "cursor:auto">
                                    <img class="author_headImg" v-bind:src="disposeUrl1(model.map,model.author)">
                                </a>
                                <span class="author_name" style="max-width:200px;"  v-html="$options.filters.highLightMsg(model.type=='5'?(model.publicName||model.name):model.name)" v-bind:title="model.name"  @dblclick="selectText($event)">{{model.name}}</span>
                            </div>
                            <div class="author_info shop_author_info" v-if="model.type=='3'">
                                <a class="tooltip-box top " v-if="!model.origin" style = "cursor:auto">
                                    <img class="author_headImg scene_author_headImg" :src="model.origin?model.origin.headImg:disposeHeadImg1(model.headImg)"/>
                                </a>
                                <a class="tooltip-box top " v-if="model.origin" style = "cursor:auto">
                                    <img class="author_headImg scene_author_headImg" :src="model.origin?model.origin.headImg:disposeHeadImg(model.headImg)"/>
                                </a>
                                <span class="author_name no-effect" v-html="$options.filters.highLightMsg(model.name)" v-bind:title="model.name"  @dblclick="selectText($event)">{{model.name}}</span>
                            </div>
                            <div class="model_info">
                                <div class="model_seen model_time tooltip-box top"  v-bind:data-content="convertUTCTimeToLocalTime(model.cTime)" v-on:mouseenter="showTooltip" v-on:mouseleave="cancelTooltip">
                                    <i class="fa fa-calendar fa-fw"></i>
                                </div>
                                <div class="model_seen tooltip-box top" data-content="资源参考值" v-on:mouseenter="showTooltip" v-on:mouseleave="cancelTooltip" v-if="model.type!='3'&&model.type!='4'&&model.type!='5'">
                                    <i class="fa fa-file-archive-o"></i>{{formatBytes(model.projectSize)}}
                                </div>
                                <div class="model_seen tooltip-box top" data-content="资源参考值" v-on:mouseenter="showTooltip" v-on:mouseleave="cancelTooltip" v-if="model.type=='3'||model.type=='4'||model.type=='5'">
                                    <i class="fa fa-file-archive-o"></i>{{formatBytes(model.resourceSize)}}
                                </div>
                                <div class="model_seen tooltip-box top" data-content="浏览次数" v-on:mouseenter="showTooltip" v-on:mouseleave="cancelTooltip">
                                    <i class="fa fa-eye fa-fw"></i>{{formatNumber(model.browse)}}
                                </div>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
            <div class="modelList_footer">
                <h4 class="text_muted" v-if="!isLoadComplete">加载中...</h4>
				<div class="load_more_btn" v-on:click="loadMore" v-if="!isLastPage&&isLoadComplete">加载更多<i class="fa fa-arrow-circle-o-down"></i></div>
				<h4 v-if="isLastPage" class="text_muted">已显示全部</h4>
			</div>
        </div>
    </div>
</template>

<script>
    import bus from '../assets/js/eventBus.js';
    import crypto from 'crypto-browserify';
    import Identicon from 'identicon.js';
    import shield from '../assets/js/shield.js';
    var vm;
    var timer;
    var lastTime;
    export default {
        nanme:"projectList_box",
        data:function(){
            return{
                Path: "https://www.thingjs.com",
                otherPath:"http://www.thingjs.com",
                projectPath: "http://www.thingjs.com/guide/sampleindex.html?m=",
                editProjectPath:"https://www.thingjs.com/guide/?m=sample&o=",
                chartProjectPath: "https://www.thingjs.com/chart/publish/",
                headPath:'https://www.thingjs.com/',
                headPath1:'http://www.3dmomoda.com/',
                infoPath:'http://www.3dmomoda.com/scene/info/',
                previewPath:'http://www.3dmomoda.com/browse',
                Path1: "https://www.thingjs.com/citybuilder_console/",
                viewPath:"https://www.thingjs.com/citybuilder/#/projectPreview?model=preview&logo=false&template=false",
                imgPath : "https://www.thingjs.com",
                showList:[],
                queryData: {
					type:"projectList",
					bigType: "",
					smallType: "",
					keyWord: "",
					pageSize: 24,
					pageNumber: 1,
                    sort: "zonghe",
                    isAPP:false
                },
                ignore:['1642682536e64ff3','1642682269672180','164268251123fdb8','1642682488bb6cfa','16497468865f7907'], //不显示购买
                isLastPage:false,
                message:[],
                isLoadComplete:false,
                panelShow:false,
                openUrl:''
            }
        },
        beforeCreate() {
            vm = this;
        },
        methods:{
            selectText(e){
                var e=e||window.event;
                e.stopPropagation();
                e.preventDefault();
                document.getSelection().selectAllChildren(document.getSelection().focusNode.parentNode);
                document.execCommand('copy');
            },
            processingUrl:function(path){
                var backPath = path.toString().replace(/\\/g, "/");
                return this.Path1+backPath;
            },
            disposeHeadImg1:function(url){
               if(this.isEmpty(url)){
                    return '../../static/img/user_img.png';
                }else{
                    var urlHeader = url.substring(0,4);
                    if(urlHeader == 'http'){
                        return url;
                    }else{
                        var headType = url.substring(0,7);
                        if(headType=='headImg'){
                            return this.headPath1 + url;
                        }else{
                            if(url.substring(0,6)=='models'){
                                return this.headPath1 + url;
                            }
                            return this.headPath + url;
                        }
                    }
                }
            },
            isEmpty:function (obj){
                if(typeof obj == "undefined" || obj == null || obj == ""){
                    return true;
                }else{
                    return false;
                }
            },
            disposeUrl1:function(url,userNick){
                if(!!url){
                    var urlHeader = url.substring(0,4);
                    if(urlHeader == 'http'){
                        return url;
                    }else{
                        return this.imgPath + url;
                    }
                }else{
                    if(userNick == null){
                        userNick = 'thingjs';
                    }
                    var hash = crypto.createHash('md5');
                    hash.update(userNick);
                    var imgData = new Identicon(hash.digest('hex')).toString();
                    var imgUrl = 'data:image/png;base64,'+imgData;
                    return imgUrl;
                return imgUrl;
                    return imgUrl;
                }
            },
            disposeUrl:function(userNick,url){
                if(this.isEmpty(userNick)){
                    userNick = 'thingjs';
                }
                if(this.isEmpty(url)){
                    var hash = crypto.createHash('md5');
                    hash.update(userNick);
                    var imgData = new Identicon(hash.digest('hex')).toString();
                    var imgUrl = 'data:image/png;base64,'+imgData;
                    return imgUrl;
                }else{
                    var urlHeader = url.substring(0,4);
                    if(urlHeader == 'http'){
                        return url;
                    }else{
                        return this.Path + this.encodeAno(url);
                    }
                }
            },
            formatBytes:function(bytes, decimals) {
                if (bytes == 0) return ' -- ';
                var k = 1024;
                var dm = decimals < 0 ? 0 : decimals;
                var sizes = ['B', 'K', 'M', 'G', 'T', 'PB', 'EB', 'ZB', 'YB'];
                var i = Math.floor(Math.log(bytes) / Math.log(k));
                return ' ' + parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + sizes[i];
            },
            disposeBackguroudPath:function(model,url){
                if(this.isEmpty(url)){
                    return false;
                }else{
                    var urlHeader = url.substring(0,4);
                    if(urlHeader == 'http'){
                        if(model.projectName=='my'){
                            return false;
                        }else{
                            return encodeURI(url);
                        }
                    }else{
                        return this.Path + url;
                    }
                }
            },
            disposeBackguroudUrl:function(url){
                if(this.isEmpty(url)){
                    return false;
                }else{
                    var urlHeader = url.substring(0,4);
                    if(urlHeader == 'http'){
                        if(this.validateImage(url)){
                            return url;
                        }else{
                            return '../../static/img/scene-default.png';
                        }
                    }else{
                        if(this.validateImage(this.Path + this.encodeAno(url))){
                            return this.Path + this.encodeAno(url);
                        }else{
                            return '../../static/img/scene-default.png';
                        }
                    }
                }
            },
            getCity:function(){
                window.open(this.openUrl,"_blank");
            },
            viewCity:function(city,index){
                var _this = this;
                if($.cookie('openid')){
                    $.ajax({
                        url:_this.Path1+'mapProject/uploadCjs?name=&originProjectId=&projectId=' + city.code,
                        type:'post',
                        data:{
                            projectId: city.code
                        },
						headers: {
                            'openid': getCookie('openid', true),
                            'token': getCookie('token')
                        },
                        dataType:'json',
                        success: function (d) {
                            if (d.success == 1 && d.data && d.data.fixedCjsPath) {
                                var fPath = d.data.fixedCjsPath;
                                var mmdId = getCookie("mmdId");
                                var mapName =city.name;
                                var reData = {
                                    'type': 'city',
                                    'preUrl': fPath,
                                    'name': mapName,
                                    'mmdId': mmdId,
                                    'bgimg':city.off_thumb?city.off_thumb:_this.processingUrl(city.picPath)
                                }
                                let isMmdidLegitimate;
                                try{
                                    isMmdidLegitimate = this.$global.AntiSqlValid(mmdId);
                                }catch(e){
                                    isMmdidLegitimate = true;
                                }
                                if(isMmdidLegitimate){
                                    _this.$reqs.post("/api/getPreviewUrl?"+Math.random(),reData).then(function(result) {
                                        if(result.data && result.data.state) {
                                            var openUrl ='https://www.thingjs.com' + result.data.content;
                                            window.open(openUrl,"_blank");
                                        } else {
                                            console.log("获取地址失败！");
                                        }
                                    }).catch(function(error) {
                                        console.log("获取地址失败！"+error);
                                    });
                                }
                            }
                        }
                    });
                }else{
                    logoinForStore();
                }
            },
            noPlugInPreviewScene:function(item,flag){
                console.log(item,"item")
                if(flag){
                    var msg = {title:'预览项目',subject:'prjAll_scene',toolInfo:{data:item}};
                    bus.$emit('view',msg);
                    return
                }
                var _this =this;
                if($.cookie('openid')){
                    if(item.type == 4 || item.type == 5) {
                        var sceneUrl = item.path;
                        var sceneName = item.name;
                    }else{
                        var sceneUrl = './client/ThingJS/' + item.userid + '/' + item.id;
                        var sceneName = sceneUrl.split('/').pop();
                    }
                    var mmdId = $.cookie("mmdId");

                    var reData = {
                        'type': 'scene',
                        'preUrl': sceneUrl,
                        'name': sceneName,
                        'mmdId': mmdId,
                        'bgimg':item.off_thumb?item.off_thumb:'http://www.3dmomoda.com:80/models/'+item.id+'.jpg'
                    }
                    let isMmdidLegitimate;
                    try{
                        isMmdidLegitimate = this.$global.AntiSqlValid(mmdId);
                    }catch(e){
                        isMmdidLegitimate = true;
                    }
                    if(isMmdidLegitimate){
                        _this.$reqs.post("/api/getPreviewUrl?"+Math.random(),reData).then(function(result) {
                            if(result.data && result.data.state) {
                                var openUrl ='https://www.thingjs.com' + result.data.content;
                                _this.$reqs.get("/scene/addSceneViewCount?viewId="+item.id+"&type="+item.type, {}).then(function(result) {
                                    window.open(openUrl,"_blank");
                                }).catch(function(error) {
                                    window.open(openUrl,"_blank");
                                    console.log(error);
                                });
                            } else {
                                console.log("获取地址失败！");
                            }
                        }).catch(function(error) {
                            console.log("获取地址失败！"+error);
                        });
                    }
                }else{
                   logoinForStore();
                }
            },
            validateImage:function (url){
                var xmlHttp ;
                if (window.ActiveXObject){
                    xmlHttp = new ActiveXObject("Microsoft.XMLHTTP");
                }else if (window.XMLHttpRequest){
                    xmlHttp = new XMLHttpRequest();
                }
                xmlHttp.open("Get",url,false);
                xmlHttp.send();
                if(xmlHttp.status==404){
                    return false;
                }else{
                    return true;
                }
            },
            disposeProjectUrl:function(data){
                if(this.isEmpty(data.projectJs)){
                    return false;
                }else{
                    var urlHeader =data.projectJs.substring(0,4);
                    if(urlHeader == 'http'){
                        return data.projectJs;
                    }else{
                        if(data.link){
                            if(data.browseType &&data.browseType =='http'){
                                var newPath = data.projectJs.indexOf('/project/')>0?this.otherPath +"/p/":this.otherPath +"/pp/";
                                return newPath +　data.link;
                            }else{
                                var newPath = data.projectJs.indexOf('/project/')>0?this.Path +"/p/":this.Path +"/pp/";
                                return newPath +　data.link;
                            }
                        }else{
                            var newurl = data.projectJs.substr(1);
                            return this.projectPath + this.encodeAno(newurl);
                        }
                    }
                }
            },
            showTooltip: function(event) {
				var content = $(event.target).data("content");
				var tipEle ='<div class="tooltips"><div class="arrow"></div>' + content +'</div>';
				$(event.target).append(tipEle);
			},
			cancelTooltip: function(event) {
				$("div").remove(".tooltips");
            },
            showTooltip1: function(event) {
                var content = $(event.target).data("content");
                var tipEle ='<div class="tooltips"><div class="arrow"></div>' + content +'</div>';
                $(event.target).append(tipEle);
                var leftPx = Number('-' + parseInt($('.tooltips').width())/2);
                $('.projectList_info .project_author_info .top .tooltips').css({
                    "left":leftPx,
                    "transition-duration":"0s"
                });
                $('.modelList_info .city_author_info .top .tooltips').css({
                    "left":leftPx,
                    "transition-duration":"0s"
                });
                 $('.modelList_info .shop_author_info .top .tooltips').css({
                    "left":leftPx,
                    "transition-duration":"0s"
                });
            },
            cancelTooltip1: function(event) {
                $("div").remove(".tooltips");
                $('.projectList_info .project_author_info .top .tooltips').css({
                    "left":"0px",
                    "transition-duration":"0s"
                });
                $('.modelList_info .city_author_info .top .tooltips').css({
                    "left":"0px",
                    "transition-duration":"0s"
                });
                $('.modelList_info .shop_author_info .top .tooltips').css({
                    "left":"0px",
                    "transition-duration":"0s"
                });
            },
			formatNumber: function(number) {
				if(number < 1000) {
					return number;
				} else {
					return(number / 1000).toFixed(1) + "k";
				}
            },
            loadMore: function() {
                this.queryData.pageNumber++;
                this.queryModelList(this.queryData);
            },
            encodeAno:function (a) {
                a = encodeURI(a);
                return a.substr(0, a.lastIndexOf('/')) + a.substr( a.lastIndexOf('/')).replace(/0/g, '02').replace(/%/g, '01');
            },
            queryModelList:function(data){
                var _this = this;
                var _list = this.showList;
                _this.isLoadComplete = true;
                this.$reqs.post("/all/getAll?"+Math.random(), data).then(function(result) {
                    if(result.data && result.data.state) {
                        var content = result.data.content.list;
                        var contentLen = content.length;
                        for(var i = 0; i < contentLen; i++) {
                            if(content[i].p_id&&(_this.ignore.indexOf(content[i].p_id)!=-1)) content[i].isShopping=0;
                            _list.push(content[i]);
                        }
                        if(data.keyWord){
                            bus.$emit('changeListCount',contentLen);
                            _this.isLoadComplete = true;
                            _this.isLastPage = false;
                            if(contentLen==0){
                                _this.isLoadComplete = true;
                                _this.isLastPage = true;
                                bus.$emit('lockScroll',true);
                            }
                        }else{
                            bus.$emit('changeListCount',result.data.content.allnums);
                            _this.isLastPage = false;
                        }
                    }else{
                        console.log('queryProjectList error');
                    }
                }).catch(function(error) {
                    console.log('queryProjectList error'+error);
                });
            },
            throttle: function(fn){
                let that = this;
                let now = +new Date();
                if(lastTime && lastTime - now < 2000){
                    clearTimeout(timer)
                }
                timer = setTimeout(function () {
                    fn.apply(that);
                    lastTime = +new Date()
                },200)
            },
            viewScene:function(data,flag){
                let self=this;
                var fn=function(){
                if(flag){
                    var msg = {title:'预览项目',subject:'prjAll',toolInfo:{data:data}};
                    bus.$emit('view',msg);
                    return
                }
                window.AnalysysAgent && window.AnalysysAgent.track('ResourcesCenter_Click', {
                    resources: '项目',
                    type:'全部',
                    projectName: data.projectName,
                    projectID: data.idd + ''
                })
                if($.cookie('openid')){
                    if(this.disposeProjectUrl(data)){
                        var openUrl = "";
                        if(data.chartId == "undefined" || data.chartId == null || data.chartId == ""){
                            openUrl = this.disposeProjectUrl(data);
                        }else {
                            openUrl = this.chartProjectPath + data.chartId;
                        }
                        this.$reqs.get("/project/addProjectViewCount?viewId="+encodeURIComponent(data.projectJs), {}).then(function(result) {
                            window.open(openUrl,"_blank");
                        }).catch(function(error) {
                            window.open(openUrl,"_blank");
                            console.log(error);
                        });
                    }else{
                        console.log('暂时无法预览');
                    }
                }else{
                   logoinForStore();
                }
                }
                self.throttle(fn,500);
            },
            editScene:function(data){
                if($.cookie('openid')){
                    if(data.isOpen=='1'){
                        console.log('暂时无法编辑');
                        return;
                    }else{
                        var urlHeader =data.isOpen.substring(0,4);
                        if(urlHeader == 'http'){
                            window.open(data.isOpen,"_blank");
                        }else{
                            var openUrl = this.editProjectPath + data.isOpen;
                            window.open(openUrl,"_blank");
                        }
                    }
                }else{
                   logoinForStore();
                }
            },
            convertUTCTimeToLocalTime: function(UTCDateString) {
				if(!UTCDateString) {
					return this.message.createTime;
				}
				function formatFunc(str) {
					return str > 9 ? str : '0' + str
				}
				var date2 = new Date(UTCDateString);
				var year = date2.getFullYear();
				var mon = formatFunc(date2.getMonth() + 1);
				var day = formatFunc(date2.getDate());
				var hour = date2.getHours();
				var sec = date2.getSeconds();
				hour = formatFunc(hour);
				sec = formatFunc(sec);
				var min = formatFunc(date2.getMinutes());
				var dateStr = year + '-' + mon + '-' + day + ' ' + hour + ':' + min + ':' + sec;
				return dateStr;
            },
            isMobile() {
                let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
                return flag;
            },
            saleProject(data,flag = true) {
                // console.log('购买项目2all')
                if(flag){
                    var msg = {title:'购买项目',subject:'project_buy_saleProject',toolInfo:{data:data}};
                    bus.$emit('view',msg);
                    return
                }
                 if($.cookie('openid')){
                   if(data.isTemplate == 1 && data.terff != 0 && data.torder){
                        var tOrderId = $.cookie('mmdId') + ".ThingJS_Template." + data.torder;
                        layer.open({
                            type: 2,
                            title: false,
                            closeBtn: 0,
                            area: ['585px', '568px'],
                            content: [
                                window.location.protocol+'//www.thingjs.com/static/payment/createPay/paymentOrder.html?type=ThingJS_Template&userId=' +
                                $.cookie('mmdId') + '&tOrderId=' + tOrderId, 'no'
                            ],
                            skin: 'buyModelDiv',
                            success:function(){
                                document.getElementsByClassName('buyModelDiv')[0].querySelector('.layui-layer-content').children[0].contentWindow.postMessage({paySource:location.href}, '*');
                            }
                        });
                        window.addEventListener('message', function (event) {
                            if(event.data&&event.data.type&&event.data.type=="newStyle") {
                                $(".buyModelDiv").css({"border-radius":"8px","background-color": "transparent"});
                                $(".buyModelDiv iframe").css("border-radius","8px");
                            }
                            if (event.data == 'close') {
                                layer.closeAll();
                            }
                        })
                    }else{
                        // this.panelShow = true;
                        var name = data.projectName?data.projectName:data.name
                        var msg = {
                            "subject":'saleProject',
                            "projectName":"购买项目："+name,
                            type:'ThingJS_ForProject',
                            id:data.p_id
                        }
                        // console.log(msg)
                        if(this.disposeProjectUrl(data)){
                            var openUrl = "";
                            if(data.chartId == "undefined" || data.chartId == null || data.chartId == ""){
                                openUrl = this.disposeProjectUrl(data);
                            }else {
                                openUrl = this.chartProjectPath + data.chartId;
                            }
                            this.$reqs.get("/project/addProjectViewCount?viewId="+encodeURIComponent(data.projectJs), {}).then(function(result) {
                                msg.url = openUrl;
                                // window.parent.postMessage({"type":"saleProject","msg":msg},'*');
                                bus.$emit("sales",msg);
                            }).catch(function(error) {
                                msg.url = openUrl;
                                bus.$emit("sales",msg);
                                // window.parent.postMessage({"type":"saleProject","msg":msg},'*');
                                console.log(error);
                            });
                        }else{
                            msg.url='';
                        }
                    }
                }else{
                   logoinForStore();
                }
            },
            saleCity:function(city,flag = true){
                // console.log('购买项目3all')
                if(flag){
                    var msg = {title:'购买项目',subject:'project_buy_saleCity',toolInfo:{data:city}};
                    bus.$emit('view',msg);
                    return
                }
                if($.cookie('openid')){
                    // this.panelShow = true;
                    var name = city.projectName?city.projectName:city.name;
                    var msg = {
                        "type":'saleProject',
                        "projectName":"购买项目："+name,
                        type:'ThingJS_ForCity',
                        id:city.code
                    }
                    // console.log(msg)
                    var _this = this;
                    $.ajax({
                        url:_this.Path+'/citybuilder_console/mapProject/uploadCjs?name=&originProjectId=&projectId=' + city.code,
                        type:'post',
                        data:{
                            projectId: city.code
                        },
						headers: {
                            'openid': getCookie('openid', true),
                            'token': getCookie('token')
                        },
                        dataType:'json',
                        success: function (d) {
                            if (d.success == 1 && d.data && d.data.fixedCjsPath) {
                                var fPath = d.data.fixedCjsPath;
                                var mmdId = getCookie("mmdId");
                                var mapName =city.name;
                                var reData = {
                                    'type': 'city',
                                    'preUrl': fPath,
                                    'name': mapName,
                                    'mmdId': mmdId,
                                    'bgimg':city.off_thumb?city.off_thumb:_this.processingUrl(city.picPath)
                                }
                                let isMmdidLegitimate;
                                try{
                                    isMmdidLegitimate = this.$global.AntiSqlValid(mmdId);
                                }catch(e){
                                    isMmdidLegitimate = true;
                                }
                                if(isMmdidLegitimate){
                                    _this.$reqs.post("/api/getPreviewUrl",reData).then(function(result) {
                                        if(result.data && result.data.state) {
                                            msg.url ='https://www.thingjs.com' + result.data.content;

                                        } else {
                                            msg.url = ''
                                            console.log("获取地址失败！");
                                        }
                                        bus.$emit("sales",msg);
                                        // window.parent.postMessage({"type":"saleProject","msg":msg},'*');
                                    }).catch(function(error) {
                                        console.log("获取地址失败！"+error);
                                        msg.url = '';
                                        bus.$emit("sales",msg);
                                        // window.parent.postMessage({"type":"saleProject","msg":msg},'*');
                                    });
                                }
                            }
                        }
                    });
                }else{
                    logoinForStore();
                }
            },
            saleScenes(item, flag = true) {
                // console.log('购买项目4all')
                if(flag){
                    var msg = {title:'购买项目',subject:'project_buy_saleScenes',toolInfo:{data:item}};
                    bus.$emit('view',msg);
                    return
                }
                var _this =this;
                if($.cookie('openid')){
                    // this.panelShow = true;
                    var name = item.projectName?item.projectName:item.name;
                    var msg = {
                        "type":'saleProject',
                        "projectName":"购买项目："+name,
                        type:'ThingJS_ForScene',
                        id:item.id
                    }
                    // console.log(msg)
                    var sceneUrl = './client/ThingJS/' + item.userid + '/' + item.id;
                    var sceneName = sceneUrl.split('/').pop();
                    var mmdId = $.cookie("mmdId");
                    var reData = {
                        'type': 'scene',
                        'preUrl': sceneUrl,
                        'name': sceneName,
                        'mmdId': mmdId,
                        'bgimg':item.off_thumb?item.off_thumb:'http://www.3dmomoda.com:80/models/'+item.id+'.jpg'
                    }
                    let isMmdidLegitimate;
                    try{
                        isMmdidLegitimate = this.$global.AntiSqlValid(mmdId);
                    }catch(e){
                        isMmdidLegitimate = true;
                    }
                    if(isMmdidLegitimate){
                        _this.$reqs.post("/api/getPreviewUrl",reData).then(function(result) {
                            if(result.data && result.data.state) {
                                var openUrl ='https://www.thingjs.com' + result.data.content;
                                _this.$reqs.get("/scene/addSceneViewCount?viewId="+item.id+"&type="+item.type, {}).then(function(result) {
                                    msg.url = openUrl;
                                    bus.$emit("sales",msg);
                                    // window.parent.postMessage({"type":"saleProject","msg":msg},'*');
                                }).catch(function(error) {
                                    msg.url = '';
                                    bus.$emit("sales",msg);
                                    // window.parent.postMessage({"type":"saleProject","msg":msg},'*');
                                    console.log(error);
                                });
                            } else {
                                msg.url = '';
                                bus.$emit("sales",msg);
                                // window.parent.postMessage({"type":"saleProject","msg":msg},'*');
                                console.log("获取地址失败！");
                            }
                        }).catch(function(error) {
                            msg.url = '';
                            bus.$emit("sales",msg);
                            // window.parent.postMessage({"type":"saleProject","msg":msg},'*');
                            console.log("获取地址失败！"+error);
                        });
                    }
                }else{
                   logoinForStore();
                }
            },
            hidePanel:function(success) {
                var _this = this;
                this.panelShow = false;
            },
        },
        beforeDestroy () {
            bus.$off("addProjectlList");
            bus.$off("changeAllList");
            bus.$off("showProjectNull");
        },
        mounted(){
            var _this = this;
            if(shield.shieldWords.indexOf($("#keyword").val())=='-1'){
                this.queryData.keyWord = $("#keyword").val();
            }
            this.queryData.sort = $('.active').attr('data-sort');
            this.queryModelList(this.queryData);
            bus.$on("showProjectNull",(data) =>{
                this.showList = [];
                bus.$emit('changeListCount','-1');
                this.isLastPage = true;
            });
            bus.$on("changeAllList",(data) =>{
                this.showList = [];
                this.isLastPage = false;
                this.queryData = JSON.parse(JSON.stringify(data));
                this.queryModelList(data);
            });
            bus.$on("addProjectlList", (data) => {
                _this.queryData.pageNumber++;
                this.queryModelList(_this.queryData);
            });
            bus.$on("prjAll",(data) => {
                this.viewScene(data,false);
            }),

            bus.$on("prjAll_scene",(data) => {
                this.noPlugInPreviewScene(data,false);
            })
            bus.$on("prjAll_city",(data) => {
                this.viewCity(data,0,false);
            }),

            // 首页全部购买留资拦截 —— saleProject
            bus.$on("project_buy_saleProject",(data) => {
                // console.log('project_buy_saleProject')
                this.saleProject(data,false);
            })
            // 首页全部购买留资拦截 —— saleCity
            bus.$on("project_buy_saleCity",(data) => {
                // console.log('project_buy_saleCity')
                this.saleCity(data,'',false);
            })
            // 首页全部购买留资拦截 —— saleScenes
            bus.$on("project_buy_saleScenes",(data) => {
                // console.log('project_buy_saleScenes')
                this.saleScenes(data,'',false);
            })
            if (_this.isMobile()) {
                this.queryData.isAPP = true;
            } else {
                this.queryData.isAPP = false;
            }
        },
        filters:{
            highLightMsg:function(value){
                if(vm.queryData && vm.queryData.keyWord){
                    var reg = new RegExp(vm.queryData.keyWord,"g");
                    if(value.indexOf(vm.queryData.keyWord) != -1){
                        return value.replace(reg,'<span class="highlight">'+vm.queryData.keyWord+'</span>')
                    }else{
                        return value;
                    }
                }else{
                    return value ;
                }
            },
            highLightkeyWord:function(value){
                if(vm.queryData && vm.queryData.keyWord){
                    var reg = new RegExp(vm.queryData.keyWord,"g");
                    if(value.indexOf(vm.queryData.keyWord) != -1){
                        return value.replace(reg,'<span class="highlight">'+vm.queryData.keyWord+'</span>')
                    }else{
                        return false;
                    }
                }else{
                    return false;
                }
            }
        }
    }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/projectListAll.vue